var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dg-link',{attrs:{"href":_vm.linkTo,"type":"primary"}},[_vm._v(_vm._s(_vm.$t("ppm.list_section.column_labels.details")))])
}
var staticRenderFns = []

export { render, staticRenderFns }